<template>
  <v-dialog
    content-class="vuedl-layout"
    v-model="isActive"
    :fullscreen="fullscreen"
    ref="vdialog"
    :max-width="getWidth"
    :persistent="persistent || loading"
    :scrollable="scrollable"
    @keydown.esc="dismiss"
  >
    <div
      v-if="showClose && !persistent && !loading"
      class="vuedl-layout__closeBtn"
      @click.stop="close">
      ×
    </div>
    <dialog-child
      v-bind="$options.propsData"
      ref="dialog" />
  </v-dialog>
</template>

<script>
export default {
  props: {
    // ref: String,
    fullscreen: Boolean,
    scrollable: Boolean,
    showClose: {
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    _destroy () {
      // Allow to draw transition, cause vuetify doesn't have onClose method
      setTimeout(() => {
        this.$destroy()
      }, 1000)
    }
  }
}
</script>
<style>
  .vuedl-layout {
    position: relative;
  }
  .vuedl-layout__closeBtn {
    position: absolute;
    top: 0px;
    font-family: -webkit-pictograph;
    right: 14px;
    font-size: 29px;
    opacity: 0.5;
    z-index: 1000;
    cursor: pointer;
  }
  .vuedl-layout__closeBtn:hover {
    opacity: 1;
  }
</style>
